import { Component, inject, Input, OnInit } from '@angular/core'
import Passkey from '@account/Passkey'
import { MatDialogRef } from '@angular/material/dialog'
import { NgStyle } from '@angular/common'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { TextInputComponent } from '@ui/Components/Form/TextInput/TextInput.Component'
import { DialogActionsComponent } from '@ui/Components/Dialog/DialogActions.Component'
import { ButtonComponent } from '@ui/Components/Form/Button/Button.Component'

@Component({
	selector: 'rename-passkey-dialog',
	templateUrl: './RenamePasskeyDialog.Component.html',
	imports: [
		NgStyle,
		DialogComponent,
		TextInputComponent,
		DialogActionsComponent,
		ButtonComponent,
	],
})
export class RenamePasskeyDialogComponent implements OnInit {
	@Input() public passkey: Passkey

	public name: string

	private readonly dialogRef: MatDialogRef<RenamePasskeyDialogComponent>

	constructor() {
		this.dialogRef = inject(MatDialogRef<RenamePasskeyDialogComponent>)
	}

	public ngOnInit() {
		this.name = this.passkey.name
	}

	public confirmAndClose = () => {
		this.dialogRef.close({
			...this.passkey,
			name: this.name,
		})
	}
}
